import { render, staticRenderFns } from "./headerview.vue?vue&type=template&id=eddfbaf0&scoped=true&"
import script from "./headerview.vue?vue&type=script&lang=js&"
export * from "./headerview.vue?vue&type=script&lang=js&"
import style0 from "./headerview.vue?vue&type=style&index=0&id=eddfbaf0&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddfbaf0",
  null
  
)

export default component.exports